import global from "../../config/global";

import storeActions from "../../store/actions";

import userServices from "../../services/user";
import authServices from "../../services/auth";
import paymentServices from "../../services/payment";
import resourceServices from "../../services/resource";
import onboardingServices from "../../services/onboarding";
import chatwootServices from "../../services/chatwoot";
import enterpriseServices from "../../services/enterprise";

import common from ".";
import i18n from "../../config/i18n";

const getPaymentPlan = async () => {
  const plan = await paymentServices.get_payments_plan();
  global.store.dispatch(storeActions.updatePaymentsPlan(plan));
}

const getPlanLimit = async () => {
  const response = await paymentServices.get_payments_plan_limit();
  global.store.dispatch(storeActions.updatePlanLimit(response))
}

const getAllCiphers = async () => {
  const result = await global.jsCore.cipherService.getAllDecrypted() || []
  const allCiphers = result.map(item => {
    const i = common.parseNotesOfNewTypes(item)
    i.checked = false
    return i
  })
  global.store.dispatch(storeActions.updateAllCiphers(allCiphers));
  await getPlanLimit();
}

const fetchUserInfo = async () => {
  await Promise.all([
    userServices.get_me(),
    userServices.users_me(),
    userServices.block_by_2fa(),
    resourceServices.get_lang(),
    userServices.users_me_prelogin(),
  ]).then(async ([
    userMe,
    userPm,
    blockBy2fa,
    resourceLang,
    userMePrelogin,
  ]) => {
    try {
      await common.getEnterpriseInvitations();
      await global.jsCore?.vaultTimeoutService?.setVaultTimeoutOptions(userPm.timeout, userPm.timeout_action);
      updateLocale(userMe.customer_language)
    } catch (error) {
    }
    let chatwoot = null
    try {
      chatwoot = await chatwootServices.get_user_chatwoot();
    } catch (error) {
      chatwoot = null
    }
    let backupPwl = []
    try {
      await common.serviceSetApiToken();
      backupPwl = await service?.listBackupPasswordless() || [];
    } catch (error) {
      backupPwl = []
    }
    global.store.dispatch(storeActions.updateUserInfo({
      ...userMe,
      ...userPm,
      ...blockBy2fa,
      ...userMePrelogin,
      chatwoot,
      passkeys: backupPwl?.filter((k) => k.type !== 'hmac'),
      security_keys: backupPwl?.filter((k) => k.type === 'hmac'),
      resourceLang
    }));
  }).catch(() => {
    authServices.logout();
  });
}

const updateLocale = async (language) => {
  let locale = language;
  if (!global.constants.LANGUAGES.find((l) => l.value === language)) {
    locale = global.constants.LANGUAGE.EN
  }
  global.store.dispatch(storeActions.changeLanguage(locale));
  common.updateLanguage(locale);
  i18n.changeLanguage(locale);
}

const togglePlanNoticeModal = (callback = () => { }) => {
  if (common.isPremiumFeaturesAvailable()) {
    callback();
  } else {
    const showPremiumActions = global.store.getState().permission.showPremiumActions;
    if (showPremiumActions) {
      global.store.dispatch(storeActions.updatePlanNoticeVisible(true));
    } else {
      callback();
    }
  }
}

const getResourceCountries = async () => {
  const countries = await resourceServices.get_countries();
  global.store.dispatch(storeActions.updateCountries(countries));
}

const getResourcePlans = async () => {
  const plans = await resourceServices.get_plans();
  global.store.dispatch(storeActions.updatePlans(plans));
}

const updateOnboardingProcess = async (key) => {
  const tutorialProcess = global.store.getState().onboarding.tutorialProcess || [];
  if (!tutorialProcess.includes(key)) {
    await onboardingServices.update_onboarding({
      tutorial_process: [...tutorialProcess, key]
    });
    global.store.dispatch(storeActions.updateReloadOnboarding(new Date().getTime()));
  }
}

const getEnterpriseInvitations = async () => {
  const invitations = await enterpriseServices.get_enterprises_invitations() || [];
  global.store.dispatch(storeActions.updateEnterpriseInvitations(invitations));
}


export default {
  getPaymentPlan,
  getPlanLimit,
  togglePlanNoticeModal,
  getAllCiphers,
  fetchUserInfo,
  updateLocale,
  getResourcePlans,
  getResourceCountries,
  updateOnboardingProcess,
  getEnterpriseInvitations
}